import { gql } from '@apollo/client';

export const GET_LISTING_AVERAGE_SELLING_TIME_FOR_POWER_SUPPLIES = gql`
  query GetListingAverageSellingTimeForPowerSupplies($vendorNames: [String!]!, $country: Country) {
    getListingAverageSellingTimeForPowerSupplies(input: { vendorNames: $vendorNames, country: $country }) {
      powerSupply
      sellingTimeInDays
    }
  }
`;
